import { ApolloClient, InMemoryCache } from '@apollo/client/core';
import type { NormalizedCacheObject } from '@apollo/client/core';
import { WebSocketLink } from '@apollo/client/link/ws';

export default ApolloClient;

function apolloClientFactory(): () => ApolloClient<NormalizedCacheObject> {
  let client: ApolloClient<NormalizedCacheObject> | undefined;
  return () => {
    if (!client) {
      const wsLink = new WebSocketLink({
        uri: 'wss://smart-search.sembo.com/graphql',
        options: {
          reconnect: true,
        },
      });
      client = new ApolloClient({
        link: wsLink,
        cache: new InMemoryCache({
          typePolicies: {
            TimeSlotsQL: {
              keyFields: ['timeSlotId', 'startTime'],
            },
            AgeRangeQL: {
              keyFields: ['ageRangeId', 'price'],
            },
            SegmentQL: {
              keyFields: [
                'flightNumber',
                'departureDateTime',
                'arrivalDateTime',
              ],
            },
          },
        }),
        connectToDevTools: true,
      });
    }
    return client;
  };
}

export const getApolloClient = apolloClientFactory();
